module.exports = __webpack_public_path__ + "static/greens-acorn-1169cfbc8e1db76d3f7cf638256a46db.mp4";